import { Link } from 'react-router-dom';

export interface CrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: CrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
            {item.to && !isLast ? (
              <Link to={item.to} className="text-foreground-500 transition-colors hover:text-primary-700">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-foreground-800' : 'text-foreground-500'}>
                {item.label}
              </span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-300" />}
          </span>
        );
      })}
    </nav>
  );
}